module.exports = __webpack_public_path__ + "img/lyq_img1.62d05ec3.png";